import React from "react";

import { Notifications } from "./components/Notifications";

export const BpMobileNotifications: React.FC = () => {
  return <Notifications />;
};
